import { useCallback, useMemo } from "react";
import { withGenericConfig } from "/contexts/generic-config-context";
import SelectWithIcon from "components/core/select-with-icon/select-with-icon";
import { getCategoryName, getCategoryId } from "template-store/services/solution-categories-service";
import { getSolutionCategoryPageLink } from "template-store/services/solution-links-service";
import { MENU_CATEGORY_CLICKED, SOLUTION_STORE_SEARCH_COMPLETED } from "/constants/bigbrain-event-types";
import { trackEvent } from "services/bigbrain-service";
import { HOME_ID } from "template-store/constants/categories";
import dynamic from "next/dynamic";
import SearchIcon from "monday-ui-react-core/dist/icons/Search";
import CloseSmall from "monday-ui-react-core/dist/icons/CloseSmall";
import Favorite from "monday-ui-react-core/dist/icons/Favorite";
import { componentStyles } from "./mobile-navigation-component.scss";

const Search = dynamic(() => import("monday-ui-react-core/dist/Search"), {
  ssr: false
});

const MobileTemplatesNavigation = (props) => {
  const { allCategories, translate, selectedCategoryId, onSearchChange, searchTerm, showSearch, focusOnSearch } = props;

  const categoryOptions = useMemo(() => {
    const categories = allCategories.map((categoryData) => {
      const categoryId = getCategoryId(categoryData);
      const categoryName = getCategoryName(categoryData);
      return { value: categoryId, label: categoryName };
    });
    categories.unshift({
      value: HOME_ID,
      label: translate("templateCenter.template.featured"),
      iconComponent: Favorite
    });
    return categories;
  }, [allCategories, translate]);

  const selectedOption = useMemo(() => {
    return categoryOptions.find((option) => option.value === selectedCategoryId);
  }, [categoryOptions, selectedCategoryId]);

  const chooseCategory = useCallback(
    (option) => {
      if (!option?.value || option?.value === selectedCategoryId) return;

      const link = getSolutionCategoryPageLink(option.value);
      trackEvent(MENU_CATEGORY_CLICKED, { kind: option.value });
      window.location = link;
    },
    [selectedCategoryId]
  );

  const onSearchBlur = useCallback((e) => {
    trackEvent(SOLUTION_STORE_SEARCH_COMPLETED, { kind: e?.target?.value });
  }, []);

  return (
    <div className="mobile-navigation-component">
      <div className="mobile-category-wrapper">
        <SelectWithIcon
          className="category-dropdown"
          value={selectedOption}
          classNamePrefix="select"
          isClearable={false}
          isSearchable={false}
          name="category"
          options={categoryOptions}
          onChange={chooseCategory}
        />
      </div>
      {showSearch && (
        <div className="mobile-search-wrapper">
          <Search
            placeholder={translate("templateCenter.template.search")}
            onChange={onSearchChange}
            value={searchTerm}
            iconName={SearchIcon}
            secondaryIconName={CloseSmall}
            onBlur={onSearchBlur}
            autoFocus={focusOnSearch}
          />
        </div>
      )}

      <style jsx>{componentStyles}</style>
    </div>
  );
};

MobileTemplatesNavigation.defaultProps = {
  showSearch: false
};

export default withGenericConfig(MobileTemplatesNavigation);
